module.exports = __webpack_public_path__ + "img/instabank.00e1a987.svg";